<template>
    <div class="text-justify" style="font-size: 12px; line-height: 150%">
        <p>
            <strong
                ><span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
                >&nbsp;</strong
            >&ndash; adalah Platform aplikasi yang dikembangkan oleh
            {{ VUE_ENV.VUE_APP_COMPANY_NAME }}.
        </p>
        <p>
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            menghormati privasi pengguna dan berkomitmen untuk melindunginya
            dalam segala hal. Informasi tentang pengguna yang dikumpulkan oleh
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            adalah: (a) informasi yang diberikan oleh pengguna dan (b) informasi
            secara otomatis diberi oleh telepon gengam penguna. Dengan
            menggunakan atau layanan aplikasi
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, anda setuju untuk pengumpulan, penyimpanan, dan penggunaan
            informasi pribadi yang anda berikan untuk layanan yang kami
            tawarkan. Untuk memanfaatkan aplikasi jasa
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, pengguna diharuskan untuk memberikan informasi tertentu untuk
            proses pendaftaran yang mungkin termasuk namun tidak terbatas pada :
            a) nama Anda, b) nomor telepon, c) password.
        </p>
        <p>
            Kebijakan Privasi ini (&ldquo;Kebijakan&rdquo;) menjelaskan
            bagaimana
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> ({{
                VUE_ENV.VUE_APP_COMPANY_NAME
            }}), perusahaan yang terasosiasi dan entitas-entitas yang
            dikendalikan secara bersama melalui
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dalam
            mengumpulkan, menggunakan dan memproses Data Pribadi Anda melalui
            penggunaan Aplikasi dan Situs website, produk-produk, fitur-fitur
            dan layanan lainnya secara umum (&ldquo;Layanan&rdquo;). Kebijakan
            ini berlaku untuk para mitra, agen dan member
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            (secara kolektif disebut &ldquo;Anda&rdquo; atau
            &ldquo;Pengguna&rdquo;).
        </p>
        <p><strong>Data Pribadi</strong></p>
        <p>
            Adalah segala informasi yang dapat digunakan untuk mengidentifikasi
            Anda atau dari mana Anda dapat diidentifikasi. Ini termasuk namun
            tidak terbatas pada nama anda, jenis kelamin, tempat lahir, tanggal
            lahir, nomor telepon, IMEI, alamat rumah, daftar Kontak, GPS, alamat
            email, gambar anda dan nomor identifikasi yang dikeluarkan
            pemerintah tentang Anda yang mana telah Anda berikan kepada
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dalam
            formulir pendaftaran, formulir aplikasi atau bentuk serupa lainnya
            dan/atau informasi tentang Anda yang telah, atau mungkin dikumpulkan
            disimpan, digunakan dan diproses oleh
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dari
            waktu ke waktu.
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            menggunakan layanan pihak ketiga yang dapat mengumpulkan informasi
            yang digunakan untuk mengidentifikasi Anda.
        </p>
        <p><strong>Pengumpulan Data Pribadi</strong></p>
        <p>
            Penyediaan Data Pribadi Anda bersifat sukarela. Namun, jika Anda
            tidak memberikan Data Pribadi Anda,
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> tidak
            dapat memproses Data Pribadi Anda untuk Tujuan dan Tujuan Tambahan
            yang diuraikan di bawah ini dan dapat menyebabkan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> tidak
            dapat memberikan layanan-layanan atau produk-produk kepada atau
            menerima pembayaran-pembayaran dari Anda. Anda dapat memberikan Data
            Pribadi Anda kepada kami ketika Anda atau berasal dari:
        </p>
        <p>
            Mengisi formulir pendaftaran atau registrasi atau formulir serupa
            lainnya.
        </p>
        <p>
            Dari sumber yang tersedia untuk umum seperti media massa, buku,
            posting pada media sosial.
        </p>
        <ul>
            <li>Berinteraksi pada halaman media sosial Kami.</li>
            <li>
                Dari mitra pelaporan kredit, penyedia asuransi, atau penyedia
                jasa keuangan.
            </li>
            <li>
                Ketika Anda ditambahkan sebagai kontak darurat oleh Pengguna
                Kami.
            </li>
            <li>
                Saat Anda berpartisipasi dan berkomunikasi dengan
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                di setiap acara-acara atau kegiatan-kegiatan.
            </li>
            <li>
                Menggunakan fitur biometrik untuk mengidentifikasi diri Anda.
            </li>
            <li>Mengisi informasi demografis dalam survei.</li>
        </ul>
        <p>
            Dengan menggunakan aplikasi dan situs
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, termasuk semua aplikasi dan situs web yang dioperasikan oleh
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, dan dibawah nama masing-masing. Merek tersebut (masing-masing
            disebut &ldquo;Apps&rdquo; dan &ldquo;Websites&rdquo;).
        </p>
        <p><strong>Data Pribadi Individu Lain</strong></p>
        <p>
            Dalam beberapa situasi, Anda dapat memberikan Data Pribadi orang
            lain (seperti pasangan, anggota keluarga, kerabat atau teman Anda)
            kepada kami. Misalnya, Anda dapat menambahkannya sebagai kontak
            darurat. Jika Anda memberikan kepada kami Data Pribadi mereka, Anda
            menyatakan dan menjamin bahwa Anda telah dan Anda telah memperoleh
            persetujuan mereka untuk Data Pribadi mereka untuk dikumpulkan,
            digunakan dan diungkapkan sebagaimana diatur dalam Kebijakan ini.
        </p>
        <p><strong>Tujuan</strong></p>
        <p>
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dapat
            menggunakan dan memproses Data Pribadi Anda untuk proses verifikasi,
            validasi, transaksi pengiriman dan logistik, pembayaran, pembelian
            dan jasa keuangan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> yang
            mencakup, namun tidak terbatas pada hal berikut
            (&ldquo;Tujuan&rdquo;):
        </p>
        <p>Apabila Anda adalah Pengguna :</p>
        <ul>
            <li>
                Untuk melakukan kewajiban-kewajiban
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                sehubungan dengan perjanjian yang Anda sepakati.
            </li>
            <li>
                Untuk memproses dan memberikan layanan yang Anda inginkan
                seperti layanan keuangan digital dan layanan lainnya yang
                memerlukan data milik Anda.
            </li>
            <li>
                Di mana Anda telah meminta untuk mengunduh dan menggunakan
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                atau aplikasi
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                lainnya untuk memproses permintaan Anda, untuk menyampaikan
                Aplikasi kepada Anda dan memberi Anda lisensi untuk penggunaan
                Aplikasi.
            </li>
            <li>
                Untuk memproses partisipasi Anda dalam setiap acara-acara
                (events), kegiatan-kegiatan, kelompok kerja, studi penelitian,
                perlombaan, promosi, polling atau survei.
            </li>
            <li>
                Untuk memproses, mengelola atau memverifikasi pendaftaran Anda
                untuk berlangganan dengan
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                dan untuk memberi Anda keuntungan yang ditawarkan sebagai
                Pengguna.
            </li>
            <li>
                Untuk memverifikasi dan memvalidasi pemesanan Anda dan memproses
                pembayaran yang berkaitan dengan produk atau layanan yang Anda
                ajukan.
            </li>
            <li>
                Untuk memahami dan menganalisis penjualan Kami serta kebutuhan
                dan preferensi Anda.
            </li>
            <li>
                Mengembangkan, meningkatkan dan menyediakan produk-produk dan
                layanan-layanan untuk memenuhi kebutuhan Anda.
            </li>
            <li>Untuk memproses penukaran atau pengembalian produk.</li>
            <li>Memproses dan mengelola hadiah-hadiah Anda.</li>
            <li>
                Menggunakan cookies untuk meningkatkan pemrosesan, periklanan,
                pemberitahuan, otentikasi, keamanan, kepatuhan dan analisis
                kami.
            </li>
        </ul>
        <p>Umum</p>
        <ul>
            <li>
                Untuk menanggapi pertanyaan, komentar dan jawaban dari Anda.
            </li>
            <li>
                Untuk berkomunikasi dengan Anda sehubungan dengan segala hal
                yang disebutkan dalam Kebijakan ini.
            </li>
            <li>
                Untuk tujuan administratif internal, seperti audit, analisis
                data dan rekaman-rekaman dalam database.
            </li>
            <li>
                Untuk tujuan mendeteksi/penemuan, pencegahan dan penuntutan
                tindak pidana.
            </li>
            <li>
                Agar
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                dapat mematuhi kewajibannya berdasarkan hukum yang berlaku.
            </li>
            <li>
                Dan Anda sepakat dan menyetujui
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                menggunakan dan memproses Data Pribadi Anda untuk Tujuan dan
                dengan cara yang disebutkan dalam Kebijakan ini.
            </li>
        </ul>
        <p><strong>Pemeliharaan Data Pribadi</strong></p>
        <p>
            Kami dapat memelihara Data Pribadi Anda meski Anda sudah tidak lagi
            menjadi mitra atau pengguna layanan kami. Ketika Data Pribadi Anda
            tidak diperlukan untuk penyediaan Layanan atau Tujuan Penggunaan
            Data Pribadi, atau Kami tidak lagi memiliki tujuan baik secara hukum
            maupun bisnis untuk memelihara Data Pribadi Anda, kami dapat
            mengambil tindakan untuk mencegah akses atau penggunaan Data Pribadi
            tersebut untuk tujuan apapun selain dari pemenuhan kewajiban kami
            terhadap Kebijakan Privasi ini atau tujuan keamanan, pencegahan dan
            deteksi penipuan.
        </p>
        <p><strong>Pengungkapan kepada Pihak Ketiga</strong></p>
        <p>
            Data Pribadi Anda dapat ditransmisikan, dinilai atau diungkapkan
            kepada pihak ketiga untuk Tujuan dan Tujuan Tambahan. Lebih lanjut,
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dapat
            menggunakan perusahaan-perusahaan lain, penyedia jasa atau
            perorangan untuk melakukan fungsinya atas nama
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dan
            bersamaan juga dapat memberikan akses atau mengungkapkannya ke Data
            Pribadi Anda kepada petugas lapangan atau pihak ketiga. Para pihak
            ketiga termasuk, namun tidak terbatas pada:
        </p>
        <ul>
            <li>
                Mitra
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
                >, termasuk pihak-pihak dengan siapa
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                bekerja sama untuk acara-acara, program-program dan
                kegiatan-kegiatan tertentu.
            </li>
            <li>Perusahaan pengiklanan.</li>
            <li>
                Perusahaan-perusahaan manajemen acara dan sponsor acara-acara.
            </li>
            <li>Perusahaan-perusahaan riset pemasaran.</li>
            <li>
                Penyedia layanan, termasuk, penyedia layanan teknologi informasi
                untuk pekerjaan infrastruktur, perangkat lunak dan pembangunan.
            </li>
            <li>
                Penasihat profesional dan auditor eksternal, termasuk penasihat
                hukum, penasihat keuangan dan konsultan.
            </li>
            <li>
                Entitas lain dalam
                <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
                dan pihak berwajib, penegak hukum atau pemerintahan yang
                berwenang untuk mematuhi persyaratan- persyaratan
                perundang-undangan dan peraturan-peraturan.
            </li>
        </ul>
        <p><strong>Cookies</strong></p>
        <p>
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dan
            pihak ketiga yang bekerjasama dengan kami dapat menggunakan cookies,
            web beacons, tags, scripts, local shared objects yaitu HTML5 dan
            Flash (secara umum biasa disebut sebagai &ldquo;flash
            cookies&rdquo;), advertising identifiers (termasuk pengenal seluler
            seperti IDFA milik Apple atau Identitas Pemasaran milik Google) dan
            teknologi serupa (&ldquo;Cookies&rdquo;).
        </p>
        <p>
            Sehubungan dengan penggunaan Websites dan Apps Anda. Cookies
            memiliki pengidentifikasi unik dan tersimpan dalam komputer atau
            perangkat bergerak Anda, surat elektronik yang kami kirimkan kepada
            Anda dan pada Websites kami. Cookies dapat mengirimkan Data Pribadi
            Anda dan penggunaan Layanan Anda, termasuk tipe browser, preferensi
            pencarian Anda, alamat IP, data terkait pemasaran yang telah
            ditampilkan dan dipilih oleh Anda, tanggal serta waktu penggunaan
            Anda. Cookies dapat tersimpan hanya selama sesi penggunaan pribadi.
        </p>
        <p>
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dapat
            mengizinkan pihak ketiga untuk menggunakan cookies di Websites dan
            Apps untuk mengumpulkan jenis informasi yang sama dalam tujuan yang
            sama seperti yang dilakukan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            untuknya. Pihak ketiga mungkin dapat menghubungkan informasi yang
            mereka kumpulkan dengan informasi lain yang mereka miliki tentang
            Anda dari sumber lain. Kami tidak memiliki akses terhadap atau
            kontrol atas cookies yang mereka gunakan. Selain itu, Kami juga
            dapat membagikan informasi non-personal dari atau tentang Anda
            kepada pihak ketiga, seperti data lokasi, advertising identifiers,
            atau cryptographic hash dari common account identifier (seperti
            alamat email), untuk memfasilitasi tampilan iklan yang ditargetkan.
            Jika Anda tidak ingin Data Pribadi Anda dikumpulkan melalui cookies
            di Websites, Anda dapat menonaktifkan cookies dengan menyesuaikan
            pengaturan browser internet Anda untuk menonaktifkan, memblokir atau
            menonaktifkan cookies, dengan menghapus riwayat penjelajahan Anda
            dan membersihkan cache dari browser internet Anda. Anda juga dapat
            membatasi pembagian beberapa informasi ini melalui pengaturan
            perangkat seluler Anda.
        </p>
        <p><strong>Tautan ke Websites Pihak Ketiga</strong></p>
        <p>
            Websites dapat berisi tautan ke situs web pihak ketiga.
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> tidak
            bertanggung jawab atas pengumpulan, penggunaan, pemeliharaan,
            pembagian, atau pengungkapan data dan informasi oleh pihak ketiga
            tersebut. Jika Anda memberikan informasi langsung ke situs tersebut,
            kebijakan privasi dan ketentuan layanan di situs tersebut akan
            berlaku dan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> tidak
            bertanggung jawab atas kegiatan pengolahan informasi atau kebijakan
            privasi dari situs tersebut.
        </p>
        <p>
            <strong
                >Informasi Pribadi dari Anak di bawah Umur dan Individu
                Lainnya</strong
            >
        </p>
        <p>
            Sebagai orang tua atau wali yang sah, mohon untuk tidak mengizinkan
            anak di bawah umur (dibawah 18 [delapan belas] tahun) yang berada
            dalam pengawasan Anda untuk memberikan Data Pribadi ke
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >. Jika Data Pribadi tersebut diberikan kepada
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, Anda dengan ini menyetujui pemrosesan Data Pribadi anak dibawah
            umur tersebut dan secara pribadi menerima dan setuju untuk terikat
            oleh Kebijakan ini dan bertanggung jawab atas tindakannya. Dalam
            keadaan tertentu, Anda mungkin telah memberikan Data Pribadi yang
            berkaitan dengan orang lain (seperti pasangan, anggota keluarga atau
            orang yang dekat dengan Anda) dan dalam keadaan tersebut, Anda
            mewakili dan menjamin bahwa Anda diberi wewenang untuk memberikan
            Data Pribadi mereka ke
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dan
            Anda telah memperoleh persetujuan dari mereka untuk Data Pribadi
            mereka diproses dan digunakan sebagaimana diatur dalam Kebijakan
            ini.
        </p>
        <p><strong>Tujuan Hukum</strong></p>
        <p>
            Kami dapat menggunakan Data Pribadi yang kami kumpulkan untuk
            menyelidiki dan menyelesaikan klaim atau perselisihan, atau
            sebagaimana diizinkan atau disyaratkan oleh undang-undang yang
            berlaku. Kami juga dapat menggunakan Data Pribadi Anda ketika kami
            diharuskan, disarankan, direkomendasikan, diharapkan atau diminta
            untuk melakukannya oleh penasihat hukum Kami atau penasihat hukum
            setempat atau asing, peraturan, pemerintah atau otoritas lainnya.
        </p>
        <p>Misalnya, kami dapat menggunakan Data Pribadi Anda untuk:</p>
        <ul>
            <li>
                Mematuhi perintah pengadilan atau persyaratan hukum, pemerintah
                atau peraturan lainnya.
            </li>
            <li>
                Melaksanakan Syarat dan Ketentuan Pengguna atau perjanjian
                lainnya.
            </li>
            <li>
                Melindungi hak atau properti milik kami jika terjadi klaim atau
                perselisihan. Data Pribadi Anda juga dapat dibagikan sehubungan
                dengan adanya transaksi perusahaan, seperti pembentukan
                perusahaan patungan, penjualan anak perusahaan atau divisi,
                penggabungan, konsolidasi, atau penjualan aset, atau likuidasi.
            </li>
        </ul>
        <p><strong>Dukungan Pelanggan</strong></p>
        <p>
            Kami menggunakan Data Pribadi untuk menyelesaikan masalah dukungan
            pelanggan.
        </p>
        <p>Sebagai contoh, Kami dapat:</p>
        <ul>
            <li>Menyelidiki dan mengatasi masalah.</li>
            <li>Memantau dan meningkatkan respons dukungan pelanggan Kami.</li>
            <li>Menanggapi pertanyaan, komentar, dan tanggapan.</li>
            <li>
                Memberitahukan Anda tentang langkah-langkah yang dapat dilakukan
                untuk menyelesaikan masalah dukungan pelanggan.
            </li>
        </ul>
        <p><strong>Pengakuan dan Persetujuan</strong></p>
        <p>
            Dengan berkomunikasi dengan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, menggunakan layanan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, membeli produk-produk dari
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> atau
            berdasarkan kerjasama Anda dengan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, Anda mengakui bahwa Anda telah membaca dan memahami Kebijakan ini
            dan setuju serta menyetujui penggunaan, pemrosesan dan pengalihan
            Data Pribadi Anda oleh
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            sebagaimana dijelaskan dalam Kebijakan ini.
        </p>
        <p>
            <strong>Persetujuan Penarikan dan Penghapusan Data Pribadi</strong>
        </p>
        <p>
            Anda dapat menarik persetujuan Anda sehubungan dengan pengumpulan,
            akuisisi, penyimpanan, penggunaan, pemrosesan, pengontrolan,
            transfer, transmisi, pengungkapan dan/atau dan perlindungan atas
            Data Pribadi dan data atas seluler Anda yang ditetapkan dalam
            Kebijakan Privasi ini dan memohon penghapusan data tersebut
            sepanjang diperbolehkan dan/atau tidak ditentukan sebaliknya
            berdasarkan hukum dan peraturan perundang-undangan yang berlaku
            dengan mengajukan permintaan melalui Fitur "Hapus Data Akun" pada
            Aplikasi {{ VUE_ENV.VUE_APP_NAME }}. Anda memahami dan menyetujui
            bahwa penarikan persetujuan dan permintaan penghapusan Data Pribadi
            dapat mengakibatkan Anda tidak dapat lagi mengakses dan/atau
            menggunakan Platform.
        </p>
        <p><strong>Pemutakhiran</strong></p>
        <p>
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            berhak untuk setiap saat mengubah, memperbarui atau mengubah
            persyaratan dalam Kebijakan ini dengan menggantikannya dengan
            Kebijakan yang terbaru di Websites dan Apps. Dengan terus
            berkomunikasi dengan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> dan
            dengan terus menggunakan layanan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span
            >, membeli produk-produk dari
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span> atau
            dengan penggunaan lanjutan Anda dengan
            <span class="text-uppercase">{{ VUE_ENV.VUE_APP_NAME }}</span>
            sehubungan dengan modifikasi-modifikasi, pembaruan-pembaruan atau
            amandemen-amandemen Kebijakan ini, tindakan tersebut menandakan
            penerimaan Anda atas modifikasi-modifikasi tersebut,
            pembaruan-pembaruan atau amandemen-amandemen sebagaimana dimaksud.
        </p>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    export default {
        name: 'privacy-policy',
        computed: {
            ...mapState(['VUE_ENV']),
        },
    };
</script>
